module.exports = __webpack_public_path__ + "media/flags/au-d8cbaad8.svg";